import { useContext, useMemo } from 'react'

import { getDefaultRegionPlace } from 'constants/places'
import GeoContext from 'contexts/geoContext'
import { useResolvedPlaceIdentity } from 'hooks/usePlace'
import useSmartExperiencePlace from 'components/Experiences/hooks/useSmartExperiencePlace'

interface ExperienceHomepagePlace {
  place: App.Place | undefined
  placeIdentity: App.Place | App.PlaceIdentity
}

export default function useExperienceHomepagePlace(): ExperienceHomepagePlace {
  const geo = useContext(GeoContext)
  const smartPlace = useSmartExperiencePlace()
  const defaultRegionIdentity = useMemo(() => getDefaultRegionPlace(geo.currentRegionCode), [geo.currentRegionCode])
  const defaultRegionPlace = useResolvedPlaceIdentity(defaultRegionIdentity)
  const place = smartPlace ?? defaultRegionPlace
  const placeIdentity = place ?? defaultRegionIdentity

  return useMemo(() => ({ place, placeIdentity }), [place, placeIdentity])
}
